module.exports = __webpack_public_path__ + "static/media/successful-investor (1).3f737415.gif";